<div adaptToolbarContent>
    <button *adaptIfAuthorised="'manageAccess'"
            adaptButtonIcon="add"
            data-test="add-people-button"
            class="me-2"
            (click)="addPeople()">Add people</button>
</div>

<adapt-people-grid></adapt-people-grid>
